var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    { attrs: { grow: "" } },
    [
      _c(
        "w-col",
        { attrs: { md: "12", xs: "12" } },
        [
          _c(
            "w-card",
            [
              _c("w-card-title", [
                _vm._v(_vm._s(_vm.$ct("titles.extra-info"))),
              ]),
              _c("w-card-content", [
                _c("div", {
                  directives: [
                    {
                      name: "safe-html",
                      rawName: "v-safe-html",
                      value: _vm.text,
                      expression: "text",
                    },
                  ],
                }),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }